import React, { useRef, useState} from 'react';
import { useLocation } from 'react-router-dom';
import "./Header.css";
import { Link } from 'react-router-dom';
import GoogleButton from '../auth/GoogleAuth'; 
import { config } from '../config/config';
import { scrollToSection } from './scrollUtils';
import HamburgerOverlay from './HamburgerOverlay';
import { analytics } from '../firebase/firebase'; // adjust your path
import { logEvent } from 'firebase/analytics'; // GA4

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);
  const googleAuthRef = useRef(null);
    const location = useLocation();
  const isBlogPage = location.pathname === '/blog' || location.pathname.startsWith('/blog/');
  const toggleOverlay = () => setIsOpen((prev) => !prev);

  const handleLoginSuccess = (user) => {
    // Already tracked in login component
  };

  const handleLoginFailure = () => {
    // Optional
  };

  React.useEffect(() => {
    document.documentElement.style.setProperty("--main-color", config.color);
  }, [config.color]); 

  // Tracking wrapper functions
  const handleNavClick = (label) => {
    logEvent(analytics, 'header_navigation_clicked_FacelessVideo', {
      link_name: label,
    });
  };

  const handleHamburgerClick = () => {
    logEvent(analytics, 'header_hamburger_clicked_FacelessVideo', {
      button_name: 'Hamburger Menu',
    });
    toggleOverlay();
  };

  return (
    <header className="header-landing-page" role="banner">
      {/* Left Side */}
      <div className="header-left-landing-page">
        <img
          src={config.logolanding}
          alt="Generator.video logo"
          className="logo-landing-page"
        />
        <h1 className="title-landing-page">Text to Video</h1>
      </div>

      {/* Middle Navigation */}
      <nav className="header-middle-landing-page" aria-label="Main Navigation">
        <Link
          to="/Dashboard"
          className="header-btn-landing-page"
          onClick={() => handleNavClick('Dashboard')}
        >
          Dashboard
        </Link>

        <button
          className="header-btn-landing-page"
          onClick={() => {
            handleNavClick('About Us');
            scrollToSection('Footer');
          }}
        >
          About Us
        </button>

        <button
          className="header-btn-landing-page"
          onClick={() => {
            handleNavClick('Contact');
            scrollToSection('Footer');
          }}
        >
          Contact
        </button>

            <Link
      to={isBlogPage ? '/' : '/blog'}
      className="header-btn-landing-page"
      onClick={() => handleNavClick(isBlogPage ? 'Home' : 'Blog')}
    >
      {isBlogPage ? 'Home' : 'Blog'}
    </Link>

      </nav>

      {/* Right Side - Google Login */}
      <div className="header-right-landing-page">
        <GoogleButton
          id="login-btn-landing-page"
          ref={googleAuthRef}
          onLoginSuccess={handleLoginSuccess}
          onClick={handleLoginFailure}
        />
      </div>

      {/* Hamburger Menu (Mobile) */}
      <img
        src={config.hamburger}
        alt="Menu"
        className="hamburger"
        onClick={handleHamburgerClick}
      />
      <HamburgerOverlay
        isOpen={isOpen}
        toggleOverlay={toggleOverlay}
        config={config}
        GoogleButton={GoogleButton}
        handleLoginSuccess={handleLoginSuccess}
        handleLoginFailure={handleLoginFailure}
        googleAuthRef={googleAuthRef}
      />
    </header>
  );
};

export default Header;
